import {
	IFilterDefinition,
	ISelectFilterDefinition,
	ITextFilterDefinition
} from '@evinced-private/ui-common';

const searchFilter: ITextFilterDefinition = {
	id: 'searchValue',
	label: 'Search',
	filterType: 'text',
	defaultValue: '',
	componentProps: {}
};
const urlsFilter: ISelectFilterDefinition = {
	id: 'urls',
	label: 'url',
	filterType: 'select',
	defaultValue: [],
	componentProps: {
		placeholder: 'Select URL',
		allSelectedPlaceholder: 'All URLs',
		someItemsSelectedText: (numberOfItems: number) => `URLs (${numberOfItems})`,
		isMultiple: true,
		className: 'wfa-session-filter-dropdown wfa-session-url-filter',
		id: 'urls',
		label: 'URL',
		listboxWidth: '150px',
		shouldTrimOptions: true
	}
};
const severitiesFilter: ISelectFilterDefinition = {
	id: 'severities',
	label: 'severities',
	filterType: 'select',
	defaultValue: [],
	componentProps: {
		placeholder: 'Select Severity',
		allSelectedPlaceholder: 'All Severities',
		someItemsSelectedText: (numberOfItems: number) => `Severities (${numberOfItems})`,
		isMultiple: true,
		className: 'wfa-session-filter-dropdown wfa-session-severity-filter',
		id: 'severities',
		label: 'Severiy',
		listboxWidth: '150px'
	}
};
const typesFilter: ISelectFilterDefinition = {
	id: 'types',
	label: 'types',
	filterType: 'select',
	defaultValue: [],
	componentProps: {
		placeholder: 'Select Type',
		allSelectedPlaceholder: 'All Types',
		someItemsSelectedText: (numberOfItems: number) => `Types (${numberOfItems})`,
		isMultiple: true,
		className: 'wfa-session-filter-dropdown',
		id: 'types',
		label: 'Type',
		listboxWidth: '150px'
	}
};
const levelsFilter: ISelectFilterDefinition = {
	id: 'levels',
	label: 'levels',
	filterType: 'select',
	defaultValue: [],
	componentProps: {
		placeholder: 'Select Level',
		allSelectedPlaceholder: 'All Levels',
		someItemsSelectedText: (numberOfItems: number) => `Levels (${numberOfItems})`,
		isMultiple: true,
		className: 'wfa-session-filter-dropdown',
		id: 'levels',
		label: 'Level',
		listboxWidth: '150px'
	}
};

export const wfaSingleSessionFilterDefinitions: IFilterDefinition[] = [
	searchFilter,
	severitiesFilter,
	typesFilter,
	urlsFilter,
	levelsFilter
];
